<template>
  <div id="view2" class="lv1Text">
    <div class="bread container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="background-color:#fff;padding:20px 0;">
      <div class="container">
        <el-row :gutter="20">
          <el-col :span="7" v-if="!none_product">
            <div style="border:1px solid #ddd;padding:10px;" class="div_img">
              <el-image style="width: 315px; height: 319px" :src="serve+ data.images" fit="fill"></el-image>
              <img
                v-if="data && data.choiceness == 1"
                class="div_img1"
                style="display: inline-block;"
                src="../../assets/images/share.png"
                alt
              />
            </div>
          </el-col>
          <el-col v-if="none_product" :span="7">
            <div style="width:100px;height:50px"></div>
          </el-col>
          <el-col :span="17" v-if="none_product">
            <div class="none_product_box">
              <img
                style="height:344px"
                src="https://www.bioflin.com:83/image/none/proudct404.jpg"
                alt
              />
              <div class="none_product_text">商品暂时下架啦！去看看其他商品吧！</div>
            </div>
            <router-link to="/">
              <div class="none_product_index">返回首页 >></div>
            </router-link>
          </el-col>
          <el-col :span="17" v-if="type== 0 || type==2 " v-show="!none_product">
            <div>
              <el-row>
                <el-col :span="14">
                  <span
                    style="float:right"
                    class="discount"
                    v-if="data.discount_num>0"
                  >{{data.discount_num}}折优惠</span>
                  <div style="font-size:20px;height:46px;overflow:hidden;width:492px">
                    <img
                      v-if="data && data.choiceness == 1"
                      style="display: inline-block;"
                      src="../../assets/images/share.png"
                      alt
                    />
                    {{data.title}}
                  </div>
                </el-col>
                <el-col :span="4" align="right" v-if="type==2">
                  <div class="lv0Text" style="font-size:30px">&yen;{{(data.rush_price)}}</div>
                  <div class="lv3Text">抢购价</div>
                </el-col>
                <el-col :span="4" align="right" v-if="type==2">
                  <div class="lv3Text" style="font-size:30px">
                    <s>&yen;{{(data.selling_price )}}</s>
                  </div>
                  <div class="lv3Text">原价</div>
                </el-col>
                <el-col :span="4" align="right" v-if="type==0">
                  <div
                    v-if="data.selling_price1==0"
                    class="lv0Text"
                    :style="data.selling_price>9999?{fontSize:'20px'}:{fontSize:'30px'}"
                  >&yen;询价</div>
                  <div
                    v-else
                    class="lv0Text"
                    :style="data.selling_price>9999?{fontSize:'20px'}:{fontSize:'30px'}"
                  >&yen;{{data.selling_price1}}</div>

                  <div class="lv3Text">价格</div>
                </el-col>
                <el-col :span="4" align="right" v-if="type==0">
                  <div
                    class="lv3Text"
                    :style="data.selling_price>9999?{fontSize:'20px'}:{fontSize:'30px'}"
                  >
                    <s>&yen;{{data.original_price}}</s>
                  </div>
                  <div class="lv3Text">市场价</div>
                </el-col>
              </el-row>
            </div>
            <div class="lv2Text" style="font-size:12px;margin-bottom:20px">
              <span class="lv3Text">浏览次数：</span>
              <span>{{data.views}}</span>
              <span class="lv3Text" style="margin-left:10px">销量：</span>
              <span>{{data.sales}}</span>
            </div>
            <div class="t1" v-if="type==2">
              <span style="margin-right:10px">限时抢购商品</span>
              <span style="margin-right:10px">距离结束还剩</span>
              <span>{{hours}}时 {{minutes}}分 {{seconds}}秒</span>
            </div>
            <div style="display:flex;">
              <div class="box">
                <div style="padding:10px;display:flex;justify-content:left;">
                  <div>
                    <div style="padding: 10px 0;width:300px" v-if="type==0">
                      <span>价格:</span>
                      <span
                        v-if="data.selling_price1 == 0"
                        class="lv0Text"
                        style="font-size:20px;margin-left:10px"
                      >&yen;询价</span>
                      <span
                        v-else
                        class="lv0Text"
                        style="font-size:20px;margin-left:10px"
                      >&yen;{{data.selling_price1}}</span>
                      <span class="lv3Text" style="margin-left:10px">
                        <s>&yen;{{data.original_price?data.original_price:_.ceil(data.selling_price*1.2)}}</s>
                      </span>
                    </div>
                    <div style="padding: 10px 0" v-if="type==2">
                      <span>抢购价:</span>
                      <span
                        class="lv0Text"
                        style="font-size:20px;margin-left:10px"
                      >&yen;{{data.rush_price}}</span>
                      <span class="lv3Text" style="margin-left:10px">
                        <s>&yen;{{data.selling_price}}</s>
                      </span>
                    </div>
                    <div style="padding: 10px 0;width:300px" class="lv3Text">
                      <i class="fas fa-check-circle"></i> 服务承诺
                      <i class="fas fa-check-circle" style="margin-left:10px;"></i> 正品保证
                      <i class="fas fa-check-circle" style="margin-left:10px;"></i> 极速发货
                    </div>
                  </div>
                  <div>
                    <div>
                      <div class="reduce">
                        <div style="padding:5px">在线支付立减</div>
                        <!-- <img class="reduce_img" :src="serve + '/image/logo/reduce.png'" alt /> -->
                        <div>
                          <span
                            class="reduce_money"
                          >{{Math.ceil( (data.selling_price1 - data.selling_price) * 100) / 100}}</span>
                          <span class="reduce_unit">元</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style="width:100px;height:100px;margin-left:20px">
                <qrcode-vue :value="'https://www.bioflin.com/#/product/'+id" size="100"></qrcode-vue>
                <span style="color: #e2211c;font-size:10px;">扫码分享商品</span>
              </div>
            </div>

            <div v-if="data.selling_price !=0" style="margin:20px 0;">
              <span
                style="font-size:14px;font-family:Microsoft YaHei;font-weight:300;color:rgba(102,102,102,1);"
              >数量 :</span>
              <el-input-number style="margin-left:10px" v-model="number" :min="1" size="mini"></el-input-number>
              <span class="lv3Text" v-if="info.inventory">(库存：{{info.inventory}})</span>
            </div>
            <div v-if="data.selling_price !=0">
              <el-button
                class="btn"
                @click="add"
                v-if="type==0 && inventory > 0 "
                style="color:#E2211C;background:#FFE4D0;border:1px solid rgba(238, 198, 168, 1);"
              >
                <i class="iconfont icon-shopping"></i> 加入购物车
              </el-button>

              <el-button
                class="btn"
                @click="change_inventory"
                v-if="type==0 && inventory ==  0 "
                style="color:#E2211C;background:#FFE4D0;border:1px solid rgba(238, 198, 168, 1);"
              >
                <i class="iconfont icon-shopping"></i> 加入购物车
              </el-button>
              <el-button
                v-if="inventory > 0 || data.inventory > 0 "
                type="primary"
                class="btn"
                @click="buy"
              >立即购买</el-button>

              <el-button v-else type="primary" class="btn" @click="make">立即预购</el-button>

              <el-button
                plain
                size="mini"
                class="cl-btn"
                @click="addFv"
                v-if="isFav==false&&$store.state.isLogin==true"
              >
                <i class="fas fa-heart"></i>
                <div>收藏</div>
              </el-button>
              <el-button
                plain
                size="mini"
                class="cl-btn active"
                @click="cancelFv"
                v-if="isFav==true&&$store.state.isLogin==true"
              >
                <i class="fas fa-heart"></i>
                <div>已收藏</div>
              </el-button>
            </div>

            <div v-else style="margin-top:50px;height:60px;" class="clear">
              <div
                style="color : #333;font-size:16px;margin-bottom:30px;padding-left:18px"
              >联系方式 : 400-821-3401</div>
              <a
                class="clear-item"
                href="https://www.bioflin.com:83/qr_code.html"
                target="blank"
                style="margin-right:20px"
              >
                <el-button type="primary">立即咨价</el-button>
              </a>
              <div style="height:10px;"></div>
              <a
                style="margin-right:20px;"
                class="clear-item"
                target="blank"
                href="http://wpa.qq.com/msgrd?v=3&uin=1653120607&site=qq&menu=yes"
              >
                <img
                  border="0"
                  src="http://wpa.qq.com/pa?p=2:1653120607:51"
                  alt="点我咨询"
                  title="点我咨询"
                  height="25"
                />
              </a>
              <el-popover placement="bottom" width="240" trigger="hover" @show="imageType">
                <p>
                  <img :src="serve  + images " alt />
                </p>
                <div
                  slot="reference"
                  style="cursor: pointer;  display:inline-block;*zoom:1;display:inline;width:30px"
                >
                  <i class="fab fa-weixin fa-2x" style="color:#88c512;"></i>
                </div>
              </el-popover>

              <el-button
                plain
                size="mini"
                style="float:right"
                @click="addFv"
                v-if="isFav==false&&$store.state.isLogin==true"
              >
                <i class="fas fa-star" style="margin-right:5px;"></i>收藏
              </el-button>
              <el-button
                plain
                size="mini"
                style="float:right"
                @click="cancelFv"
                v-if="isFav==true&&$store.state.isLogin==true"
              >
                <i class="fas fa-star" style="margin-right:5px;"></i>已收藏
              </el-button>
            </div>
          </el-col>
          <el-col :span="17" v-if="type==1 " v-show="!none_product">
            <div>
              <div
                style="font-size:24px;font-weight:bold;
                color:rgba(51,51,51,1);margin-bottom:10px;"
              >{{data.title}}</div>
              <div class="lv2Text" style="display:flex;font-size:14px;margin-top:30px;">
                <div
                  style="width:130px;
                  height:34px;
                  line-height:34px;
                  background:rgba(254,254,254,1);
                  border:1px solid rgba(221, 221, 221, 1);text-align:center"
                >
                  <span class="lv3Text">浏览次数：</span>
                  <span style="color:rgba(46,172,255,1);">{{data.views}}</span>
                </div>
                <div
                  style="width:130px;
                  height:34px;
                  line-height:34px;
                  background:rgba(254,254,254,1);
                  border:1px solid rgba(221, 221, 221, 1);text-align:center"
                >
                  <span class="lv3Text" style="margin-left:10px">销量：</span>
                  <span style="color:rgba(46,172,255,1);">{{data.sales}}</span>
                </div>
              </div>
              <div
                style="width:615px;
                height:80px;
                line-height:80px;
                margin-top:40px;
                background:rgba(254,254,254,1);
                border:1px solid rgba(221, 221, 221, 1);font-size:16px;
                font-weight:300;
                padding-left:20px;
                color:rgba(102,102,102,1);"
              >您所需要的实验技术和帮助，我们的技术帮您完成!</div>
              <div
                style="
                margin-top:30px;
                font-size:16px;
                font-weight:300;
                font-weight:400;
                color:rgba(51,51,51,1);"
              >服务承诺 正品保证 急速发货</div>
              <div style="margin-top:30px;height:60px;" class="clear">
                <a
                  class="clear-item"
                  href="https://www.bioflin.com:83/qr_code.html"
                  target="blank"
                  style="margin-right:20px"
                >
                  <el-button type="primary">立即咨价</el-button>
                </a>
                <div style="height:10px;"></div>
                <a
                  style="margin-right:20px;"
                  class="clear-item"
                  target="blank"
                  href="http://wpa.qq.com/msgrd?v=3&uin=1653120607&site=qq&menu=yes"
                >
                  <img
                    border="0"
                    src="http://wpa.qq.com/pa?p=2:1653120607:51"
                    alt="点我咨询"
                    title="点我咨询"
                    height="25"
                  />
                </a>
                <el-popover placement="bottom" width="240" trigger="hover" @show="imageType">
                  <p>
                    <img :src="serve  + images " alt />
                  </p>
                  <div
                    slot="reference"
                    style="cursor: pointer;  display:inline-block;*zoom:1;display:inline;width:30px"
                  >
                    <i class="fab fa-weixin fa-2x" style="color:#88c512;"></i>
                  </div>
                </el-popover>

                <el-button
                  plain
                  size="mini"
                  style="float:right"
                  @click="addFv"
                  v-if="isFav==false&&$store.state.isLogin==true"
                >
                  <i class="fas fa-star" style="margin-right:5px;"></i>收藏
                </el-button>
                <el-button
                  plain
                  size="mini"
                  style="float:right"
                  @click="cancelFv"
                  v-if="isFav==true&&$store.state.isLogin==true"
                >
                  <i class="fas fa-star" style="margin-right:5px;"></i>已收藏
                </el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div style="height:360px" v-if="none_product"></div>
    <div class="container" style="margin-top:20px;" v-if="!none_product">
      <el-row :gutter="20">
        <el-col :span="19">
          <div>
            <el-tabs type="border-card">
              <el-tab-pane label="商品详情">
                <div v-if="type==0||type==2">
                  <div class="lv2Text">
                    <el-row :gutter="40">
                      <el-col :span="12">
                        <div v-if="info.brand" class="tp1">
                          <span class="lv3Text">品牌：</span>
                          {{info.brand}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.item_no" class="tp1">
                          <span class="lv3Text">货号：</span>
                          {{info.item_no}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.origin" class="tp1">
                          <span class="lv3Text">产地：</span>
                          {{info.origin}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.leadtime" class="tp1">
                          <span class="lv3Text">货期：</span>
                          {{info.leadtime==0?'现货':info.leadtime+"天"}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.specification" class="tp1">
                          <span class="lv3Text">规格：</span>
                          {{info.specification}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.uses" class="tp1">
                          <span class="lv3Text">应用：</span>
                          {{info.uses}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.molecular" class="tp1">
                          <span class="lv3Text">分子式：</span>
                          {{info.molecular}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.formula" class="tp1">
                          <span class="lv3Text">分子量：</span>
                          {{info.formula}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.CAS" class="tp1">
                          <span class="lv3Text">CAS：</span>
                          {{info.CAS}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.host" class="tp1">
                          <span class="lv3Text">宿主：</span>
                          {{info.host}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.reaction_species" class="tp1">
                          <span class="lv3Text">反应种属：</span>
                          {{info.reaction_species}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.antigen_info" class="tp1">
                          <span class="lv3Text">抗原信息：</span>
                          {{info.antigen_info}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.belong" class="tp1">
                          <span class="lv3Text">种属：</span>
                          {{info.belong}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.animal_age" class="tp1">
                          <span class="lv3Text">动物年龄：</span>
                          {{info.animal_age}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.grade" class="tp1">
                          <span class="lv3Text">等级：</span>
                          {{info.grade}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.editor" class="tp1">
                          <span class="lv3Text">主编：</span>
                          {{info.editor}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.editor" class="tp1">
                          <span class="lv3Text">主编：</span>
                          {{info.editor}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.press" class="tp1">
                          <span class="lv3Text">出版社：</span>
                          {{info.press}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.press_time" class="tp1">
                          <span class="lv3Text">图书出版时间：</span>
                          {{info.press_time}}
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div v-if="info.sell_unit" class="tp1">
                          <span class="lv3Text">出售规格：</span>
                          {{info.sell_unit}}
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-if="info.download_link">
                    <div class="ti1 lv3Text">下载文档</div>
                    <div style="text-align:center;padding:10px 0 ;">
                      <a :href="serve+info.download_link" target="_blank">
                        <el-button size="mini">
                          点击下载
                          <i class="el-icon-download el-icon--right"></i>
                        </el-button>
                      </a>
                    </div>
                  </div>
                  <div>
                    <div class="ti1 lv3Text">&nbsp;商品描述</div>
                    <div style="padding:10px 0;" v-html="info.info"></div>
                  </div>
                </div>
                <div v-html="info.info" class="lv2Text" v-if="type==1"></div>
              </el-tab-pane>

              <el-tab-pane label="评价" style="padding: 20px 10px;">
                <div v-if="!empty">
                  <div v-for="(item,index) of comments" :key="index" class="comment-item">
                    <div class="clear top1">
                      <div class="clear-item">
                        <img :src="item.headImg" class="avatar" />
                      </div>
                      <div class="clear-item lv3Text" style="margin:0 10px;">{{item.nickname}}</div>
                      <div class="clear-item" v-if="item.rank">
                        <el-rate
                          class="ra"
                          disabled
                          :value="_.toInteger(item.rank)"
                          :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                        ></el-rate>
                      </div>
                    </div>
                    <el-row>
                      <el-col :span="20" :offset="4">
                        <div class="lv2Text">{{item.content}}</div>
                        <div
                          class="lv3Text"
                          style="font-size:12px;margin:10px 0 5px 0;"
                        >{{dayjs.unix(item.create_date).format('YYYY-MM-DD hh:mm:ss')}}</div>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="pager" align="center">
                    <el-pagination
                      hide-on-single-page
                      @current-change="pageChange"
                      background
                      layout="prev, pager, next"
                      :total="total"
                      :page-size="10"
                    ></el-pagination>
                  </div>
                </div>
                <div v-else>
                  <div style="padding:20px 0;text-align:center">
                    <object
                      :data="serve+ '/images/slow_working.svg'"
                      type="image/svg+xml"
                      style="width:15%;"
                    ></object>
                  </div>
                  <div class="lv3Text" style="padding:0 0;text-align:center">暂无评价</div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="hot" align="center">
            <div class="t2">热销榜</div>
            <div v-for="(item,index) in hot" :key="index" class="hot-item">
              <router-link :to="'/product/'+item.id">
                <img lazy class="cover2" v-lazy="serve + '/'+item.images" />
              </router-link>

              <router-link :to="'/product/'+item.id">
                <div style="margin:10px 0;padding:0 10px;font-size:13px" class="title">
                  {{
                  _.truncate(item.title, {
                  'length': 18,
                  })
                  }}
                </div>
              </router-link>
              <div class="lv0Text" style="margin-bottom:10px">&yen;{{item.selling_price}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog title="温馨提示" center :visible.sync="dialogVisible" width="30%">
      <div style="text-align:center">此商品为预购商品 ，是否加入购物车?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="温馨提示" center :visible.sync="dialogVisible1" width="30%">
      <div style="text-align:center">此商品库存不足 ，超出部分属于预购商品，是否继续?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="make">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      serve: this.$store.state.serve,
      none_product: false,
      hours: null,
      minutes: null,
      seconds: null,
      isFav: false,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      id: null,
      data: {},
      number: 1,
      page: 1,
      comments: {},
      total: 0,
      hot: {},
      empty: true,
      type: 3,
      info: {},
      images: "",
      inventory: null,
      dialogVisible: false,
      dialogVisible1: false
    };
  },
  activated() {
    const P_path = this.$route.query.user_from;
    if (P_path) {
      this.$cookies.set("user_from", P_path);
    }
  },
  created() {
    this.initData();
    //库存、
    this.axios
      .get(this.serve + "/inventory_number", {
        params: {
          ids: this.id
        }
      })
      .then(res => {
        this.inventory = res.data[0].inventory;
      });
  },
  methods: {
    imageType() {
      this.axios.get(this.serve + "/guanwei_img").then(res => {
        if (res.data.status == "success") {
          this.images = res.data.data;
        }
      });
    },
    cancelFv() {
      this.axios
        .get(this.serve + "/member/cancel_collect", {
          params: {
            id: this.id,
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.isFav = false;
          }
        });
    },
    addFv() {
      this.axios
        .get(this.serve + "/member/add_collect", {
          params: {
            id: this.id,
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.isFav = true;
          }
        });
    },
    to(address) {
      window.location.href = address;
    },
    change_inventory() {
      this.dialogVisible = true;
    },
    add() {
      if (this.$store.state.isLogin) {
        var where = {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token"),
          id: this.id,
          number: this.number
        };
        if (this.info.shop_id != 0) {
          where.shop_id = this.info.shop_id;
        }
        this.axios
          .get(this.serve + "/member/add_car", {
            params: where
          })
          .then(res => {
            if (res.data.status == "success") {
              this.$message({
                type: "success",
                message: "商品已加入购物车",
                offset: 260
              });
              this.dialogVisible = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else {
        this.$router.push("/login");
      }
    },
    buy() {
      let nember = parseInt(this.number);
      let inventory = parseInt(this.inventory);
      if (inventory < nember) {
        this.dialogVisible1 = true;
        return;
      }
      var json = {
        p_id: this.data.id,
        title: this.data.title,
        item_no: this.data.item_no,
        number: this.number,
        price: this.data.selling_price,
        images: this.data.images
      };
      if (this.type == 2) {
        json.rush_id = this.$route.params.id;
        json.rush_price = this.data.rush_price;
        this.$router.push({
          path: "/user/order2",
          query: { cart: JSON.stringify([json]) }
        });
      } else if (this.type == 0) {
        var newJson = {
          p_id: this.data.id,
          number: this.number
        };
        this.$router.push({
          path: "/user/order4",
          query: newJson
        });
      }
    },
    make() {
      this.dialogVisible1 = false;
      var json = {
        p_id: this.data.id,
        title: this.data.title,
        item_no: this.data.item_no,
        number: this.number,
        price: this.data.selling_price,
        images: this.data.images
      };
      if (this.type == 2) {
        json.rush_id = this.$route.params.id;
        json.rush_price = this.data.rush_price;
        this.$router.push({
          path: "/user/order2",
          query: { cart: JSON.stringify([json]) }
        });
      } else if (this.type == 0) {
        var newJson = {
          p_id: this.data.id,
          number: this.number
        };
        this.$router.push({
          path: "/user/order4",
          query: newJson
        });
      }
    },
    pageChange(v) {
      this.page = v;
      this.axios
        .get(this.serve + "/get_product_comment", {
          params: {
            product_id: this.data.id,
            page: this.page
          }
        })
        .then(res => {
          this.comments = res.data.data.results;
          this.total = res.data.data.total;
        });
    },
    initData() {
      var path = this.$route.fullPath.split("/")[1];

      if (path == "product") {
        this.id = this.$route.params.id;
        this.axios
          .get(this.serve + "/member/has_collect", {
            params: {
              id: this.id,
              mobile: this.$cookies.get("user"),
              token: this.$cookies.get("token")
            }
          })
          .then(res => {
            if (res.data.data == "true") {
              this.isFav = true;
            }
          });

        this.axios
          .get(this.serve + "/get_product_info", {
            params: {
              mobile: this.$cookies.get("user"),
              token: this.$cookies.get("token"),
              id: this.id
            }
          })
          .then(res => {
            if (res.data.status) {
              this.none_product = true;
            } else {
              this.type = res.data.type;
              this.data = res.data.info;
              this.info = res.data.detail;
              this.hot = res.data.hot;
              this.axios
                .get(this.serve + "/get_product_comment", {
                  params: {
                    product_id: this.data.id,
                    page: this.page
                  }
                })
                .then(res => {
                  if (res.data.msg == "搜索结果为空") {
                    this.empty = true;
                  } else {
                    this.empty = false;
                    this.comments = res.data.data.results;
                    this.total = res.data.data.total;
                  }
                });
            }
          });
      } else if (path == "product2") {
        this.type = 2;
        this.axios
          .get(this.serve + "/rush_product_info", {
            params: {
              r_id: this.$route.params.id
            }
          })
          .then(res => {
            if (res.data.status) {
              this.none_product = true;
            } else {
              this.data = res.data;
              var h = this.data.end_date.split(":")[0];
              var end = new Date(
                new Date(new Date().toLocaleDateString()).getTime() +
                  h * 60 * 60 * 1000 -
                  1
              );
              var now = new Date().getTime();
              var distance = end - now;
              this.hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
              );
              this.minutes = Math.floor(
                (distance % (1000 * 60 * 60)) / (1000 * 60)
              );
              this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
              setInterval(() => {
                var now = new Date().getTime();
                var distance = end - now;
                this.hours = Math.floor(
                  (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                );
                this.minutes = Math.floor(
                  (distance % (1000 * 60 * 60)) / (1000 * 60)
                );
                this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
              }, 1000);
              this.id = this.data.product_id;
              this.axios
                .get(this.serve + "/get_product_info", {
                  params: {
                    mobile: this.$cookies.get("user"),
                    token: this.$cookies.get("token"),
                    id: this.data.product_id
                  }
                })
                .then(res => {
                  this.info = res.data.detail;
                  this.hot = res.data.hot;
                  this.axios
                    .get(this.serve + "/get_product_comment", {
                      params: {
                        product_id: this.data.product_id,
                        page: this.page
                      }
                    })
                    .then(res => {
                      if (res.data.msg == "搜索结果为空") {
                        this.empty = true;
                      } else {
                        this.empty = false;
                        this.comments = res.data.data.results;
                        this.total = res.data.data.total;
                      }
                    });
                });
            }
          });
      }
    }
  }
};
</script>
<style lang="scss">
#view2 {
  .reduce {
    font-size: 20px;
    font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
    color: #0b4992;
    padding: 10px;
    display: flex;
    justify-content: left;
    align-items: flex-end;
  }
  .reduce_img {
    width: 50px;
    height: 50px;
  }
  .reduce_money {
    font-style: italic;
    font-size: 40px;
    color: #e2211c;
  }
  .reduce_unit {
    font-size: 15px;
    color: black;
    margin-left: 6px;
  }
  .none_product_box {
    position: relative;
    .none_product_text {
      width: 577px;
      position: absolute;
      left: 0;
      bottom: 14px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(226, 33, 28, 1);
      text-align: center;
    }
  }
  .none_product_index {
    width: 577px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(226, 33, 28, 1);
    text-align: center;
    padding-bottom: 20px;
  }
  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }
  table td,
  table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
  }
  table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
  }
  .div_img {
    position: relative;
  }
  .div_img1 {
    position: absolute;
    left: 0;
    top: 0;
  }
  .t1 {
    background-color: #e36844;
    color: #fff;
    padding: 10px;
    width: 659px;
  }
  .ti1 {
    background-color: #f2f6fc;
    text-align: center;
    padding: 10px 0;
    margin: 10px 0;
  }
  .tp1 {
    border-bottom: 2px dotted #ebeef5;
    padding-bottom: 7px;
    margin-bottom: 10px;
  }
  .cl-btn.active {
    color: #f64e62;
    border-color: #f64e62;
  }
  .cl-btn {
    svg {
      margin-bottom: 2px;
    }
    margin-right: 100px;
    float: right;
    text-align: center;
    width: 50px;
    padding: 5px 0;
  }
  .discount {
    color: #fff;
    background-color: #f64e62;
    display: inline;
    padding: 2px 15px;
    font-size: 12px;
    border-radius: 8px;
    position: relative;
    bottom: 10px;
  }
  .t3 {
    background-color: #eaeaea;
    padding: 10px 0;
    text-align: center;
  }
  .avatar {
    height: 50px;
    width: 50px;
    border-radius: 50px;
  }
  .t2 {
    text-align: center;
    padding: 10px 0;
    background-color: #eee;
    margin-bottom: 20px;
  }
  .cover2 {
    height: 190px;
    width: 190px;
    margin: 0 auto;
    margin-top: 10px;
  }
  .hot {
    margin-bottom: 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    .title:hover {
      text-decoration: underline;
    }
  }
  .hot-item {
    width: 90%;
    margin-bottom: 20px;
    border: 1px solid #ddd;
  }
  .r2 {
    padding-right: 30px;
  }
  .r1 {
    padding: 10px 0;
    border-bottom: 2px dashed #ddd;
  }
  .comment-item {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  .btn {
    width: 150px;
    margin-right: 50px;
  }
  .box {
    background-color: #f2f2f2;
    border: 1px solid #ddd;
    width: 677px;
  }
  padding: 0 0 50px 0;
  .cover {
    height: 315px;
    width: 315px;
    background-position: center;
    background-size: 100% auto;
  }
}
</style>